let apiPromise;
const apiUrl = new URL(process.env.REACT_APP_YOUTUBE_IFRAME_API_URL);
if (apiUrl.protocol !== "https:" || apiUrl.hostname !== "www.youtube.com" || apiUrl.pathname !== "/iframe_api") {
  throw new Error("Invalid YouTube player API configuration");
}

export const loadYouTubePlayerApi = () => {
  if (window.YT?.Player) return Promise.resolve(window.YT);
  if (apiPromise) return apiPromise;

  apiPromise = new Promise((resolve, reject) => {
    const previousReady = window.onYouTubeIframeAPIReady;
    const script = document.createElement("script");
    let settled = false;
    let timer;
    const finish = (error) => {
      if (settled) return;
      settled = true;
      window.clearTimeout(timer);
      script.onerror = null;
      if (window.onYouTubeIframeAPIReady === ready) window.onYouTubeIframeAPIReady = previousReady;
      if (error) { script.remove(); reject(error); }
      else resolve(window.YT);
    };
    const ready = () => {
      try { previousReady?.(); }
      finally { finish(); }
    };
    window.onYouTubeIframeAPIReady = ready;
    script.src = apiUrl.toString();
    script.async = true;
    script.onerror = () => finish(new Error("YouTube player API unavailable"));
    timer = window.setTimeout(() => finish(new Error("YouTube player API timed out")), 12000);
    document.head.appendChild(script);
  }).catch((error) => { apiPromise = undefined; throw error; });

  return apiPromise;
};